export interface DebouncedDispatcher<TValue> {
  dispatch: (value: TValue) => void;
  cancel: () => void;
}

export const createDebouncedDispatcher = <TValue>(
  callback: (value: TValue) => void,
  delayMs: number
): DebouncedDispatcher<TValue> => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  const dispatch = (value: TValue) => {
    cancel();
    timeoutId = setTimeout(() => {
      callback(value);
      timeoutId = null;
    }, delayMs);
  };

  return { dispatch, cancel };
};
